export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const casinoSection = {
  popularGamesnewHome: {
    OTTAndarBahar: {
      redirectUrl: "/casino/ezg-casino-marina-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Livecasino/OTTAndarBahar.webp",
      alt: "",
      name: "OTT Andar Bahar",
      providerName: "Ezugi",
    },
    DragonTiger: {
      redirectUrl: "/casino/ezg-dragon-tiger",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/dragontiger.webp",
      alt: "",
      name: "Dragon Tiger",
      providerName: "Ezugi",
    },
    RNGCasinoQueen: {
      redirectUrl: "/casino/sn-rng-casino-queen",
      code: "RCQ",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Livecasino/RNGCasinoQueen.webp",
      alt: "",
      name: "RNG Casino Queen",
      providerName: "Supernowa",
    },
    RNGCasinoQueen2020: {
      redirectUrl: "/casino/sn-rng-casino-queen-2020",
      code: "RCQ20",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Livecasino/RNGCasinoQueen2020.webp",
      alt: "",
      name: "RNG Casino Queen 2020",
      providerName: "Supernowa",
    },
    DarkKing: {
      redirectUrl: "/casino/ezgne-dark-king-forbidden-riches",
      code: "1100081",
      casino: "ezugi",
      imgUrl: "./images/popular/Livecasino/darkkingforbiddenriches.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dark King: Forbidden Riches",
      providerName: "slots",
    },
    Autoroulette: {
      code: "56768",
      casino: "ezugi",
      provider: "Evolution",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Auto Roulette",
      name: "Auto Roulette",
      providerName: "Evolution",
      imgUrl: "./images/evolution/AutoRoulette.webp",
      redirectUrl: "/casino/ezg-auto-roulette",
    },
    JingleSpin: {
      redirectUrl: "/casino/ezgne-jingle-spin",
      code: "1100082",
      casino: "ezugi",
      imgUrl: "./images/popular/Livecasino/jinglespin.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jingle Spin",
      providerName: "slots",
    },
    JackHammer: {
      redirectUrl: "/casino/ezgne-jack-hammer",
      code: "1100084",
      casino: "ezugi",
      imgUrl: "./images/popular/Livecasino/Jackhammer.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jack Hammer",
      providerName: "slots",
    },
  },

  popularGamesnew: {
    OTTAndarBahar: {
      redirectUrl: "/casino/ezg-casino-marina-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Livecasino/OTTAndarBahar.webp",
      alt: "",
      name: "OTT Andar Bahar",
      providerName: "Ezugi",
    },
    DragonTiger: {
      redirectUrl: "/casino/ezg-dragon-tiger",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/dragontiger.webp",
      alt: "",
      name: "Dragon Tiger",
      providerName: "Ezugi",
    },
    RNGCasinoQueen: {
      redirectUrl: "/casino/sn-rng-casino-queen",
      code: "RCQ",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Livecasino/RNGCasinoQueen.webp",
      alt: "",
      name: "RNG Casino Queen",
      providerName: "Supernowa",
    },
    RNGCasinoQueen2020: {
      redirectUrl: "/casino/sn-rng-casino-queen-2020",
      code: "RCQ20",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Livecasino/RNGCasinoQueen2020.webp",
      alt: "",
      name: "RNG Casino Queen 2020",
      providerName: "Supernowa",
    },
    DarkKing: {
      redirectUrl: "/casino/ezgne-dark-king-forbidden-riches",
      code: "1100081",
      casino: "ezugi",
      imgUrl: "./images/popular/Livecasino/darkkingforbiddenriches.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dark King: Forbidden Riches",
      providerName: "slots",
    },
    JingleSpin: {
      redirectUrl: "/casino/ezgne-jingle-spin",
      code: "1100082",
      casino: "ezugi",
      imgUrl: "./images/popular/Livecasino/jinglespin.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jingle Spin",
      providerName: "slots",
    },
    JackHammer: {
      redirectUrl: "/casino/ezgne-jack-hammer",
      code: "1100084",
      casino: "ezugi",
      imgUrl: "./images/popular/Livecasino/Jackhammer.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jack Hammer",
      providerName: "slots",
    },
  },
  topGamesnew: {
    CrazyTime: {
      redirectUrl: "/casino/aggapevolutiongaming-crazy-time",
      code: "1000148",
      casino: "ezugi",
      provider: "Evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/evolution/CrazyTimeNew.webp",
      alt: "Crazy Time",
      name: "Crazy Time",
      providerName: "Evolution",
    },
    SuperAndarbahar: {
      code: "98789",
      casino: "ezugi",
      provider: "Evolution",
      homeUrl: "http://localhost:3000/Casino",
      alt: "super Andar bahar",
      name: "Super Andar Bahar",
      providerName: "Evolution",
      imgUrl: "./images/evolution/SuperAndarBaharNew.webp",
      redirectUrl: "/casino/aggapevolutiongaming-super-andar-bahar",
    },
    aviator: {
      redirectUrl: "/casino/spribe/aviator",
      code: "aviator",
      casino: "spribe",
      provider: "aviator",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Livecasino/Aviator.webp",
      alt: "",
      name: "Aviator",
      providerName: "Spribe",
    },
    AndarBahar: {
      redirectUrl: "/casino/ezg-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/top-games/AndarBahar.webp",
      alt: "",
      name: "Andar Bahar",
      providerName: "Ezugi",
    },
    CrazyTime2: {
      redirectUrl: "/casino/aggapevolutiongaming-crazy-time-2",
      code: "",
      casino: "ALT_GAMING_GAP",
      provider: "Evolution Gaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/top-games/CrazyTime2.webp",
      alt: "",
      name: "Crazy Time 2",
      providerName: "Evolution Gaming",
    },
    RNGDragonTiger: {
      redirectUrl: "/casino/sn-dragon-tiger",
      code: "VDT",
      casino: "WorldCasino",
      provider: "Supernowa",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/top-games/DragonTiger-SN.webp",
      alt: "",
      name: "Dragon Tiger",
      providerName: "Supernowa",
    },
    NamasteRoulette: {
      redirectUrl: "/casino/ezg-namaste-roulette",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/top-games/NamasteROulette.webp",
      alt: "",
      name: "Namaste Roulette",
      providerName: "Ezugi",
    },
    Onedayteenpatti1: {
      redirectUrl: "/casino/ezg-one-day-teen-patti",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/top-games/OneDayTeenPattiNew.webp",
      alt: "",
      name: "One Day Teen Patti",
      providerName: "Ezugi",
    },
    UltimateAndarBahar: {
      redirectUrl: "/casino/ezg-ultimate-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Livecasino/ultimateandarbahar.webp",
      alt: "",
      name: "Ultimate Andar Bahar",
      providerName: "Ezugi",
    },
    // ImmersiveRoulette: {
    //   redirectUrl: "/casino/ezgevo-immersive-roulette",
    //   code: "",
    //   casino: "Evolution",
    //   provider: "Ezugi",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/top-games/ImmersiveRouletteOld.webp",
    //   alt: "",
    //   name: "Immersive Roulette",
    //   providerName: "Evolution",
    // },
    XXXtremeLightningRoulette: {
      redirectUrl: "/casino/ezgevo-xxxtreme-lightning-roulette",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/top-games/XXXtremelightningroulette.webp",
      alt: "",
      name: "XXXtreme Lightning Roulette",
      providerName: "Evolution",
    },
    LightningSicBo: {
      redirectUrl: "/casino/aggapevolutiongaming-lightning-sic-bo",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Livecasino/LightningSicbo.webp",
      alt: "",
      name: "Lightning Sic Bo",
      providerName: "Evolution",
    },
    GoldVaultRoulette: {
      redirectUrl: "/casino/ezgevo-gold-vault-roulette",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/top-games/GoldVoltROulette.webp",
      alt: "",
      name: "Gold Vault Roulette",
      providerName: "Evolution",
    },
    FunkyTime: {
      redirectUrl: "/casino/ezgevo-funky-time",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/top-games/FUnkyTime.webp",
      alt: "",
      name: "Funky Time",
      providerName: "Evolution",
    },
    SpeedAutoRoulette: {
      redirectUrl: "/casino/ezgevo-speed-auto-roulette",
      code: "",
      casino: "Evolution",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/SpeedAutoRoulette-Ezg.webp",
      alt: "",
      name: "Speed Auto Roulette",
      providerName: "Ezugi",
    },

    // goal: {
    //   redirectUrl: "/casino/spribe/goal",
    //   code: "goal",
    //   casino: "spribe",
    //   provider: "goal",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/alt-gaming/InstantGame/Goal.webp",
    //   alt: "",
    //   name: "Goal",
    //   providerName: "Spribe",
    // },
    // dice: {
    //   redirectUrl: "/casino/spribe/dice",
    //   code: "dice",
    //   casino: "spribe",
    //   provider: "dice",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/alt-gaming/InstantGame/Dice.webp",
    //   alt: "",
    //   name: "Dice",
    //   providerName: "Spribe",
    // },
    // plinko: {
    //   redirectUrl: "/casino/spribe/plinko",
    //   code: "plinko",
    //   casino: "spribe",
    //   provider: "plinko",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/alt-gaming/InstantGame/plinko.webp",
    //   alt: "",
    //   name: "Plinko",
    //   providerName: "Spribe",
    // },
    // hilo: {
    //   redirectUrl: "/casino/spribe/hilo",
    //   code: "hi-lo",
    //   casino: "spribe",
    //   provider: "hi-lo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/alt-gaming/InstantGame/hilo.webp",
    //   alt: "",
    //   name: "Hilo",
    //   providerName: "Spribe",
    // },
    // keno: {
    //   redirectUrl: "/casino/spribe/keno",
    //   code: "keno",
    //   casino: "spribe",
    //   provider: "keno",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/alt-gaming/InstantGame/Keno.webp",
    //   alt: "keno",
    //   name: "Keno",
    //   providerName: "Spribe",
    // },
    GodOfWealth: {
      redirectUrl: "/casino/ezgrt-god-of-wealth",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/top-games/GodOfWealth.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "God Of Wealth",
      providerName: "slots",
    },
    ChineseTreasures: {
      redirectUrl: "/casino/ezgrt-chinese-treasures",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/top-games/chinesetreasure.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Chinese Treasures",
      providerName: "slots",
    },
    Hand2CasinoHoldem: {
      redirectUrl: "/casino/ezgevo-2-hand-casino-holdem",
      code: "1000073",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/top-games/2HandCasinoHoldem.webp",
      alt: "",
      name: " 2 Hand Casino Holdem",
      providerName: "Evolution",
    },
    BetonTeenPatti: {
      redirectUrl: "/casino/ezg-bet-on-teen-patti",
      code: "227101",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/top-games/betonteenpatti.webp",
      alt: "",
      name: "Bet on Teen Patti",
      providerName: "Ezugi",
    },
    TeenPatti3card: {
      redirectUrl: "/casino/ezg-teen-patti-3-card",
      code: "227100",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/top-games/teenpatti3card.webp",
      alt: "",
      name: " Teen Patti 3 Card",
      providerName: "Ezugi",
    },
    BlackjackVIPL: {
      redirectUrl: "/casino/ezgevo-blackjack-vip-l",
      code: "1000056",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/top-games/blackjackvipl.webp",
      alt: "",
      name: "Blackjack VIP L",
      providerName: "Evolution",
    },
    ClassicSpeedBlackjack3: {
      redirectUrl: "/casino/ezgevo-classic-speed-blackjack-3",
      code: "1000228",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/top-games/classicspeedblackjack3.webp",
      alt: "",
      name: " Classic Speed Blackjack 3  ",
      providerName: "Evolution",
    },
  },

  vivo: {
    LasVegasRoulette: {
      name: "Las Vegas Roulette",
      redirectUrl: "/casino/vivo-las-vegas-roulette",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/Vivo/LasVegasRoulette.webp",
      alt: "Las Vegas Roulette",
    },
    BlazeRoulette: {
      name: "Blaze Roulette",
      redirectUrl: "/casino/vivo-oracle-blaze-roulette",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/Vivo/BlazeRoulette.webp",
      alt: "Blaze Roulette",
    },
    BaccaratDance: {
      name: "Baccarat Dance",
      redirectUrl: "/casino/vivo-baccarat-dance",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/Vivo/BaccaratDance.webp",
      alt: "Baccarat Dance",
    },
    ImperialDragonTiger: {
      name: "Imperial Dragon Tiger",
      redirectUrl: "/casino/vivo-dragon-tiger",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/Vivo/ImperialDragonTiger.webp",
      alt: "Imperial Dragon Tiger",
    },
    CaribbeanBaccarat: {
      name: "Caribbean Baccarat",
      redirectUrl: "/casino/vivo-caribbean-baccarat",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/Vivo/CaribbeanBaccarat.webp",
      alt: "Caribbean Baccarat",
    },
    CopaCabanaBaccarat: {
      name: "Copa Cabana Baccarat",
      redirectUrl: "/casino/vivo-copa-cabana-baccarat",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/Vivo/CopaCabanaBaccarat.webp",
      alt: "Copa Cabana Baccarat",
    },
    OracleTwisterRoulette: {
      name: "Oracle Twister Roulette",
      redirectUrl: "/casino/vivo-oracle-360-roulette",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/Vivo/OracleTwisterRoulette.webp",
      alt: "Oracle Twister Roulette",
    },
    PortomasoRoulette: {
      name: "Portomaso Roulette",
      redirectUrl: "/casino/vivo-portomaso-roulette",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/Vivo/PortomasoRoulette.webp",
      alt: "Portomaso Roulette",
    },
    EuropeanAutoRoulette: {
      name: "European Auto Roulette",
      redirectUrl: "/casino/vivo-european-auto-roulette",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/Vivo/EuropeanAutoRoulette.webp",
      alt: "European Auto Roulette",
    },

    lasvegasjackpotroulette: {
      name: "Las Vegas Jackpot Roulette",
      redirectUrl: "/casino/vivo-las-vegas-jackpot-roulette",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/Vivo/lasvegasjackpotroulette.webp",
      alt: "Las Vegas Jackpot Roulette",
    },
  },

  trendinggames: {
    ColorPrediction: {
      name: "Color Prediction",
      redirectUrl: "/casino/aggapjiligaming-color-prediction",
      code: "",
      casino: "",
      provider: "Jili Gaming",
      homeUrl: "",
      providerName: "Jili",
      imgUrl: "./images/Vivo/TrendingGame/ColorPrediction.webp",
      alt: "Color Prediction",
    },
    LasVegasRoulette: {
      name: "Las Vegas Roulette",
      redirectUrl: "/casino/vivo-las-vegas-roulette",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/Vivo/TrendingGame/Lasvegasblackjack.webp",
      alt: "Las Vegas Roulette",
    },
    XXXtremeLightningRoulette: {
      name: "XXXtreme Lightning Roulette",
      redirectUrl: "/casino/ezgevo-xxxtreme-lightning-roulette",
      code: "mines",
      casino: "spribe",
      provider: "vivo",
      homeUrl: "",
      providerName: "Evolution",
      imgUrl: "./images/Vivo/TrendingGame/XXXTremelightningRoulette.webp",
      alt: "",
    },
    BlazeRoulette: {
      name: "Blaze Roulette",
      redirectUrl: "/casino/vivo-oracle-blaze-roulette",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/Vivo/TrendingGame/RouletteBlaze.webp",
      alt: "Blaze Roulette",
    },
    DragonTiger: {
      name: "Dragon Tiger",
      redirectUrl: "/casino/ezg-dragon-tiger",
      code: "goal",
      casino: "spribe",
      provider: "vivo",
      homeUrl: "",
      providerName: "Ezugi",
      imgUrl: "./images/Vivo/TrendingGame/DragonTiger.webp",
      alt: "",
    },
    ImperialDragonTiger: {
      name: "Imperial Dragon Tiger",
      redirectUrl: "/casino/vivo-dragon-tiger",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/Vivo/TrendingGame/ImperialDragonTiger.webp",
      alt: "Imperial Dragon Tiger",
    },
    LightningRoulette: {
      name: "Lightning Roulette",
      redirectUrl: "/casino/ezgevo-lightning-roulette",
      code: "dice",
      casino: "spribe",
      provider: "dice",
      homeUrl: "",
      providerName: "Evolution",
      imgUrl: "./images/Vivo/TrendingGame/LightningRoulette.webp",
      alt: "",
    },
    Poker: {
      name: "Poker",
      redirectUrl: "/casino/aura-poker",
      code: "aviator",
      casino: "spribe",
      provider: "vivo",
      homeUrl: "",
      providerName: "Aura",
      imgUrl: "./images/Vivo/TrendingGame/Poker-Aura.webp",
      alt: "",
    },
    BaccaratDance: {
      name: "Baccarat Dance",
      redirectUrl: "/casino/vivo-baccarat-dance",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/Vivo/TrendingGame/BaccaratDancing.webp",
      alt: "Baccarat Dance",
    },
    TeenpattiT20: {
      name: "Teenpatti T20",
      redirectUrl: "/casino/aura-teenpatti-t20",
      code: "mini-roulette",
      casino: "spribe",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Aura",
      imgUrl: "./images/Vivo/TrendingGame/TeenPattiT20.webp",
      alt: "",
    },
    aviator: {
      redirectUrl: "/casino/spribe/aviator",
      code: "aviator",
      casino: "spribe",
      provider: "aviator",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/Vivo/TrendingGame/Aviator.webp",
      alt: "",
      name: "Aviator",
      providerName: "Spribe",
    },
    JetXTrd: {
      redirectUrl: "/casino/aggapsmartsoftgaming-jetx",
      code: "",
      casino: "SmartSoft",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/Vivo/TrendingGame/JetXNew.webp",
      alt: "JetX",
      name: "JetX",
      providerName: "SmartSoft",
    },
  },

  recommended: {
    Aviator: {
      href: "/casinos?provider=aviatorGames",
      code: "",
      casino: "spribe",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/trending/Aviator.webp",
      alt: "Aviator",
      name: "Aviator",
    },
    Casino: {
      href: "/casinos",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/trending/CasinoNew.webp",
      alt: "Casino",
      name: "Casino",
    },
    DreamWheel: {
      href: "/casino/aggapmac88gaming-dream-wheel",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/trending/DreamWheel.webp",
      alt: "Dream Wheel",
      name: "Dream Wheel",
    },
    ChickenGames: {
      href: "/casinos?provider=jacktopGames",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/trending/ChickenGames.webp",
      alt: "Chicken Games",
      name: "Chicken Games",
    },
    ColorPrediction: {
      href: "/casinos/aggapjiligaming-color-game",
      code: "",
      casino: "Jili",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/trending/ColorPredictionLatest.webp",
      alt: "Color Prediction",
      name: "Color Prediction",
    },

    Sports: {
      href: "/sports/Inplay",
      code: "",
      casino: "Evolution",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/trending/SportsNew.webp",
      alt: "Sports",
      name: "Sports",
    },
    FootballStudio: {
      href: "/casino/ezgevo-football-studio",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/trending/FootballStudio.webp",
      alt: "Football Studio",
      name: "Football Studio",
    },
    Mines: {
      href: "/casinos/aggapmac88gamingvirtual-mines",
      code: "",
      casino: "ALT_GAMING_GAP",
      provider: "mac88",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/trending/Mines.webp",
      alt: "Mines",
      name: "Mines",
    },
  },

  popularGamesHome: {
    UltimateAndarBahar: {
      redirectUrl: "/casino/ezg-ultimate-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Livecasino/ultimateandarbahar.webp",
      alt: "",
      name: "Ultimate Andar Bahar",
      providerName: "Ezugi",
    },
    AndarBahar: {
      redirectUrl: "/casino/ezg-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Livecasino/AndarBahar.png",
      alt: "",
      name: "Andar Bahar",
      providerName: "Ezugi",
    },
    aviator: {
      redirectUrl: "/casino/spribe/aviator",
      code: "aviator",
      casino: "spribe",
      provider: "aviator",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Livecasino/Aviator.webp",
      alt: "",
      name: "Aviator",
      providerName: "Spribe",
    },
    // NoCommissionBaccarat: {
    //   redirectUrl: "/casino/ezg-no-commission-baccarat",
    //   code: "1000148",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/baccarat/no-commission-baccarat.webp",
    //   alt: "",
    //   name: "No Commission Baccarat",
    //   providerName: "Evolution",
    // },
    Lucky7: {
      redirectUrl: "/casino/ezg-lucky-7",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Livecasino/Lucky7.webp",
      alt: "",
      name: "Lucky 7",
      providerName: "Ezugi",
    },
    Onedayteenpatti1: {
      redirectUrl: "/casino/ezg-one-day-teen-patti",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Livecasino/OneDayTeenPattiClassic.webp",
      alt: "",
      name: "One Day Teen Patti",
      providerName: "Ezugi",
    },
    CricketWar: {
      redirectUrl: "/casino/ezg-cricket-war",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Livecasino/CricketWar.webp",
      alt: "",
      name: "Cricket War",
      providerName: "Ezugi",
    },
    CricketAutoRoulette: {
      redirectUrl: "/casino/ezg-cricket-auto-roulette",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Livecasino/CricketAutoroulette.webp",
      alt: "",
      name: "Cricket Auto Roulette",
      providerName: "Ezugi",
    },

    UltimateRoulette: {
      redirectUrl: "/casino/ezg-ultimate-roulette",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Livecasino/Ultimateroulette.webp",
      alt: "",
      name: "Ultimate Roulette",
      providerName: "Ezugi",
    },
    LightningSicBo: {
      redirectUrl: "/casino/aggapevolutiongaming-lightning-sic-bo",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Livecasino/LightningSicbo.webp",
      alt: "",
      name: "Lightning Sic Bo",
      providerName: "Evolution",
    },
    SpeedBaccaratA: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-a",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Livecasino/SpeedBaccaratA.webp",
      alt: "",
      name: "Speed Baccarat A",
      providerName: "Evolution",
    },
  },

  popularGames: {
    UltimateAndarBahar: {
      redirectUrl: "/casino/ezg-ultimate-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/UltimateAndarBahar.webp",
      alt: "",
      name: "Ultimate Andar Bahar",
      providerName: "Ezugi",
    },
    AndarBahar: {
      redirectUrl: "/casino/ezg-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/AndarBahar-new.webp",
      alt: "",
      name: "Andar Bahar",
      providerName: "Ezugi",
    },
    aviator: {
      redirectUrl: "/casino/spribe/aviator",
      code: "aviator",
      casino: "spribe",
      provider: "aviator",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Aviator-new.webp",
      alt: "",
      name: "Aviator",
      providerName: "Spribe",
    },
    // NoCommissionBaccarat: {
    //   redirectUrl: "/casino/ezg-no-commission-baccarat",
    //   code: "1000148",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/baccarat/no-commission-baccarat.webp",
    //   alt: "",
    //   name: "No Commission Baccarat",
    //   providerName: "Evolution",
    // },
    Lucky7: {
      redirectUrl: "/casino/ezg-lucky-7",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Lucky7.webp",
      alt: "",
      name: "Lucky 7",
      providerName: "Ezugi",
    },
    Onedayteenpatti1: {
      redirectUrl: "/casino/ezg-one-day-teen-patti",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/poker/onedayteenpatticlassic.webp",
      alt: "",
      name: "One Day Teen Patti",
      providerName: "Ezugi",
    },
    CricketWar: {
      redirectUrl: "/casino/ezg-cricket-war",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Cricketwar-new.webp",
      alt: "",
      name: "Cricket War",
      providerName: "Ezugi",
    },
    CricketAutoRoulette: {
      redirectUrl: "/casino/ezg-cricket-auto-roulette",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/CricketAutoRoulette.webp",
      alt: "",
      name: "Cricket Auto Roulette",
      providerName: "Ezugi",
    },

    UltimateRoulette: {
      redirectUrl: "/casino/ezg-ultimate-roulette",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/UltiateRoulette.webp",
      alt: "",
      name: "Ultimate Roulette",
      providerName: "Ezugi",
    },
    LightningSicBo: {
      redirectUrl: "/casino/aggapevolutiongaming-lightning-sic-bo",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/LightningSicBoOld.jpg",
      alt: "",
      name: "Lightning Sic Bo",
      providerName: "Evolution",
    },
    SpeedBaccaratA: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-a",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/SpeedBaccaratA.webp",
      alt: "",
      name: "Speed Baccarat A",
      providerName: "Evolution",
    },
  },

  mostPlayed: {
    aviator: {
      redirectUrl: "/casino/spribe/aviator",
      code: "aviator",
      casino: "spribe",
      provider: "aviator",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/alt-gaming/chicken-games/trending/Aviator1.webp",
      alt: "",
      name: "Aviator",
      providerName: "Spribe",
    },
    miniroulette: {
      redirectUrl: "/casino/spribe/miniroulette",
      code: "mini-roulette",
      casino: "spribe",
      provider: "mini-roulette",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/alt-gaming/chicken-games/trending/Miniroulette1.webp",
      alt: "",
      name: "Mini Roulette",
      providerName: "Spribe",
    },
    RockPaperScissors: {
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Rock Paper Scissors",
      name: "Rock Paper Scissors",
      providerName: "Mac88 Gaming Virtual",
      imgUrl:
        "./images/alt-gaming/chicken-games/trending/Rockpaperseasor1.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-rock-paper-scissors",
    },
    Pushpa: {
      redirectUrl: "/casino/aggapcrash88gaming-pushpa",
      code: "aviator",
      casino: "spribe",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/alt-gaming/chicken-games/trending/Pushpa1.webp",
      alt: "",
      name: "Pushpa",
      providerName: "ALT_GAMING_GAP",
    },
    Vortex: {
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Vortex",
      name: "Vortex",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/chicken-games/trending/Vortex1.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vortex",
    },
    Limbo: {
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Limbo",
      name: "Limbo",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/chicken-games/trending/Limbo1.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-limbo",
    },
    // Plinko: {
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Plinko",
    //   name: "Plinko",
    //   providerName: "Mac88 Gaming Virtual",
    //   imgUrl: "./images/alt-gaming/mac88/Plinko.webp",
    //   redirectUrl: "/casino/aggapmac88gamingvirtual-plinko",
    // },
    Dice: {
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dice",
      name: "Dice",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/chicken-games/trending/Dice1.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-dice",
    },
    diamonds: {
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Diamond",
      name: "Diamond",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/chicken-games/trending/Diamond1.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-diamonds",
    },
    mines: {
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mines",
      name: "Mines",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/chicken-games/trending/Mines1.webp",
      redirectUrl: "/casino/aggapmac88gamingvirtual-mines",
    },
    DragonTiger: {
      code: "",
      casino: "Jili",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon & Tiger",
      name: "Dragon & Tiger",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/chicken-games/trending/DragonTiger1.webp",
      redirectUrl: "/casino/aggapjiligaming-dragon-and-tiger",
    },
    ColorPrediction: {
      name: "Color Prediction",
      redirectUrl: "/casino/aggapjiligaming-color-prediction",
      code: "",
      casino: "",
      provider: "Jili Gaming",
      homeUrl: "",
      providerName: "Jili",
      imgUrl:
        "./images/alt-gaming/chicken-games/trending/Colorprediction1.webp",
      alt: "Color Prediction",
    },
    LuckyChicken: {
      code: "",
      casino: "Jacktop",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky Chicken",
      name: "Lucky Chicken",
      providerName: "Jacktop Gaming",
      imgUrl: "./images/alt-gaming/chicken-games/jacktop/LuckyChiken.webp",
      redirectUrl: "/casino/aggapjacktopgaming-lucky-chicken-crossing",
    },
    ChickenRoad: {
      code: "",
      casino: "InOut",
      provider: "WorldCasino",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Chicken Road",
      name: "Chicken Road",
      providerName: "inOut Crash",
      imgUrl: "./images/alt-gaming/chicken-games/trending/ChickenRoad1.webp",
      redirectUrl: "/casino/io-chicken-road",
    },
    EZMarbleRaceMonaco: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      alt: "EZ Marble Race Monaco",
      name: "EZ Marble Race Monaco",
      providerName: "Ezugi",
      imgUrl: "./images/alt-gaming/chicken-games/trending/ezmarbelRace.webp",
      redirectUrl: "/casino/ezg-ez-marble-race-monaco",
    },
    BetWithStreamers: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bet With Streamers",
      name: "Bet With Streamers",
      providerName: "Ezugi",
      imgUrl: "./images/alt-gaming/chicken-games/trending/betwithstreamer.webp",
      redirectUrl: "/casino/ezg-bet-with-streamers",
    },
  },

  AndarBahar: {
    OTTAndarBahar: {
      redirectUrl: "/casino/ezg-casino-marina-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/OTTAndarBahar-new.webp",
      alt: "",
      name: "OTT Andar Bahar",
      providerName: "Ezugi",
    },
    SpeedBaccaratA: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-a",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/SpeedBaccaratA.webp",
      alt: "",
      name: "Speed Baccarat A",
      providerName: "Evolution",
    },
    CricketWar: {
      redirectUrl: "/casino/ezg-cricket-war",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Cricketwar-new.webp",
      alt: "",
      name: "Cricket War",
      providerName: "Ezugi",
    },
    CricketAutoRoulette: {
      redirectUrl: "/casino/ezg-cricket-auto-roulette",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/CricketAutoRoulette.webp",
      alt: "",
      name: "Cricket Auto Roulette",
      providerName: "Ezugi",
    },
    LightningSicBo: {
      redirectUrl: "/casino/aggapevolutiongaming-lightning-sic-bo",
      code: "",
      casino: "evolution",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/lightningsicbo.webp",
      alt: "",
      name: "Lightning Sic Bo",
      providerName: "Evolution",
    },
    // AndarBahar: {
    //   redirectUrl: "/casino/ezg-andar-bahar",
    //   code: "328000",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/andarbahar/AndarBahar-new.webp",
    //   alt: "",
    //   name: "Andar Bahar",
    //   providerName: "Ezugi",
    // },
    UltimateAndarBahar: {
      redirectUrl: "/casino/ezg-ultimate-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/UltimateAndarBahar.webp",
      alt: "",
      name: "Ultimate Andar Bahar",
      providerName: "Ezugi",
    },
    AndarBahar: {
      redirectUrl: "/casino/ezg-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/AndarBahar-new.webp",
      alt: "",
      name: "Andar Bahar",
      providerName: "Ezugi",
    },
    Lucky7: {
      redirectUrl: "/casino/ezg-lucky-7",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/Lucky7.webp",
      alt: "",
      name: "Lucky 7",
      providerName: "Ezugi",
    },
    Onedayteenpatti1: {
      redirectUrl: "/casino/ezg-one-day-teen-patti",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/poker/onedayteenpatticlassic.webp",
      alt: "",
      name: "One Day Teen Patti",
      providerName: "Ezugi",
    },
  },

  roulettetab: {
    // PortomasoRouletteVivo: {
    //   redirectUrl: "/casino/vivo-portomaso-roulette",
    //   code: "",
    //   casino: "vivo",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/Vivo/vivo-portomaso-roulette.webp",
    //   alt: "vivo portomaso roulette",
    //   name: "Vivo Portomaso Roulette",
    //   providerName: "Vivo",
    // },
    // OracleBlazeRouletteVivo: {
    //   redirectUrl: "/casino/vivo-oracle-blaze-roulette",
    //   code: "",
    //   casino: "vivo",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/Vivo/vivo-oracle-blaze-roulette.webp",
    //   alt: "vivo oracle blaze roulette",
    //   name: "Vivo Oracle Blaze Roulette",
    //   providerName: "Vivo",
    // },
    // LasVegasRouletteVivo: {
    //   redirectUrl: "/casino/vivo-las-vegas-roulette",
    //   code: "",
    //   casino: "vivo",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/Vivo/vivo-las-vegas-roulette.webp",
    //   alt: "vivo las vegas roulette",
    //   name: "Vivo Las Vegas Roulette",
    //   providerName: "Vivo",
    // },
    AutoRoulette: {
      redirectUrl: "/casino/ezg-auto-roulette",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/AutoRoulette-new.webp",
      alt: "",
      name: "Auto Roulette",
      providerName: "Ezugi",
    },
    SpeedAutoRoulette: {
      redirectUrl: "/casino/ezg-speed-auto-roulette",
      code: "221002",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/SpeedAutoRoulette-new.webp",
      alt: "",
      name: "Speed Auto Roulette",
      providerName: "Ezugi",
    },
    NamasteRoulette: {
      redirectUrl: "/casino/ezg-namaste-roulette",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/NamasteRoulette-new.webp",
      alt: "",
      name: "Namaste Roulette",
      providerName: "Ezugi",
    },
    UltimateRoulette: {
      redirectUrl: "/casino/ezg-ultimate-roulette",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/UltiateRoulette.webp",
      alt: "",
      name: "Ultimate Roulette",
      providerName: "Ezugi",
    },
  },

  dragontiger: {
    // DragonTigerVivo: {
    //   redirectUrl: "/casino/vivo-dragon-tiger",
    //   code: "",
    //   casino: "vivo",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/Vivo/vivo-dragon-tiger.webp",
    //   alt: "vivo dragon tiger",
    //   name: "Vivo Dragon Tiger",
    //   providerName: "Vivo",
    // },
    DragonTiger: {
      redirectUrl: "/casino/ezg-dragon-tiger",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/Vivo/vivo-dragon-tiger.webp",
      alt: "",
      name: "Dragon Tiger",
      providerName: "Ezugi",
    },
  },

  baccarattab: {
    // MacauBaccaratVivo: {
    //   redirectUrl: "/casino/vivo-macau-baccarat",
    //   code: "",
    //   casino: "vivo",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/Vivo/vivo-macau-baccarat.webp",
    //   alt: "vivo macau baccarat",
    //   name: "Vivo Macau Baccarat",
    //   providerName: "Vivo",
    // },
    // VABacarat1: {
    //   redirectUrl: "/casino/vivo-va-bacarat-1",
    //   imgUrl: "./images/Vivo/VABacarat1.webp",
    //   name: "VA Bacarat 1",
    //   providerName: "Vivo",
    // },
    // VABacarat2: {
    //   redirectUrl: "/casino/vivo-va-bacarat-2",
    //   imgUrl: "./images/Vivo/VABacarat2.webp",
    //   name: "VA Bacarat 2",
    //   providerName: "Vivo",
    // },
    // VABacarat3: {
    //   redirectUrl: "/casino/vivo-va-bacarat-3",
    //   imgUrl: "./images/Vivo/VABacarat3.webp",
    //   name: "VA Bacarat 3",
    //   providerName: "Vivo",
    // },
    // VABacarat4: {
    //   redirectUrl: "/casino/vivo-va-bacarat-4",
    //   imgUrl: "./images/Vivo/VABacarat4.webp",
    //   name: "VA Bacarat 4",
    //   providerName: "Vivo",
    // },
    // VABacarat5: {
    //   redirectUrl: "/casino/vivo-va-bacarat-5",
    //   imgUrl: "./images/Vivo/VABacarat5.webp",
    //   name: "VA Bacarat 5",
    //   providerName: "Vivo",
    // },
    Baccarat: {
      redirectUrl: "/casino/ezg-baccarat",
      code: "101",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/baccaratezugi.webp",
      alt: "",
      name: "Baccarat",
      providerName: "Ezugi",
    },
    FortuneBaccarat: {
      redirectUrl: "/casino/ezg-fortune-baccarat",
      code: "101",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/Fortunebaccarat.webp",
      alt: "",
      name: "Fortune Baccarat",
      providerName: "Ezugi",
    },
    // NoCommissionBaccarat: {
    //   redirectUrl: "/casino/ezg-no-commission-baccarat",
    //   code: "170",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/baccarat/no-commission-baccarat.webp",
    //   alt: "",
    //   name: "No Commission Baccarat",
    //   providerName: "Ezugi",
    // },
    SpeedCricketBaccarat: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-x",
      code: "101",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/SpeedBaccaratx.webp",
      alt: "",
      name: "Speed Baccarat X",
      providerName: "Evolution",
    },
  },

  blackjacktab: {
    // LasVegasBlackjackVivo: {
    //   redirectUrl: "/casino/vivo-las-vegas-blackjack",
    //   code: "",
    //   casino: "vivo",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/Vivo/vivo-las-vegas-blackjack.webp",
    //   alt: "vivo las vegas blackjack",
    //   name: "Vivo Las Vegas Blackjack",
    //   providerName: "Vivo",
    // },
    BlackjackSilverD: {
      redirectUrl: "/casino/ezgevo-blackjack-silver-d",
      code: "1000044",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/Blackjack-Silver-D.webp",
      alt: "",
      name: "Blackjack Silver D",
      providerName: "Evolution",
    },
    BlackjackVIPE: {
      redirectUrl: "/casino/ezgevo-blackjack-vip-e",
      code: "1000052",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/Blackjack-VIP-E.webp",
      alt: "",
      name: "Blackjack VIP E",
      providerName: "Evolution",
    },
    SpeedBlackjackD: {
      redirectUrl: "/casino/ezgevo-speed-blackjack-d",
      code: "1000033",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/Speed-Blackjack-D1.webp",
      alt: "",
      name: "Speed Blackjack D",
      providerName: "Evolution",
    },
    BlackjackVIPL: {
      redirectUrl: "/casino/ezgevo-blackjack-vip-l",
      code: "1000056",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/BlackjackVIPL-new.webp",
      alt: "",
      name: "Blackjack VIP L",
      providerName: "Evolution",
    },
    ClassicSpeedBlackjack3: {
      redirectUrl: "/casino/ezgevo-classic-speed-blackjack-3",
      code: "1000228",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ClassicSpeedBlackjack3-new.webp",
      alt: "",
      name: " Classic Speed Blackjack 3  ",
      providerName: "Evolution",
    },
  },

  pokertab: {
    Hand2CasinoHoldem: {
      redirectUrl: "/casino/ezgevo-2-hand-casino-holdem",
      code: "1000073",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/poker/2HandCasinoHoldem-new.webp",
      alt: "",
      name: " 2 Hand Casino Holdem",
      providerName: "Evolution",
    },
    BetonTeenPatti: {
      redirectUrl: "/casino/ezg-bet-on-teen-patti",
      code: "227101",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/poker/BetOnTeenPatti-new.webp",
      alt: "",
      name: "Bet on Teen Patti",
      providerName: "Ezugi",
    },
    TeenPatti3card: {
      redirectUrl: "/casino/ezg-teen-patti-3-card",
      code: "227100",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/poker/TeenPatti3Card-new.webp",
      alt: "",
      name: " Teen Patti 3 Card",
      providerName: "Ezugi",
    },
    TexasHoldembonus: {
      redirectUrl: "/casino/ezgevo-texas-holdem-bonus-poker",
      code: "1000111",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/poker/TexasHoldembonus.webp",
      alt: "",
      name: "Texas Holdem Bonus",
      providerName: "Evolution",
    },
    lightningsicbo: {
      redirectUrl: "/casino/aggapevolutiongaming-lightning-sic-bo",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/popular/lightningsicbo.webp",
      alt: "",
      name: "Lightning Sic Bo",
      providerName: "Evolution",
    },
  },

  ezbonuswheel: {
    EZBonusWheel: {
      redirectUrl: "/casino/ezg-ez-bonus-wheel",
      code: "1000073",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/ezbonuswheel/EZBonusWheel.webp",
      alt: "",
      name: "EZ Bonus Wheel",
      providerName: "Ezugi",
    },
  },

  supernowa: {
    RNGCasinoQueen: {
      redirectUrl: "/casino/sn-rng-casino-queen",
      code: "RCQ",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNGCasinoQueen-new.webp",
      alt: "",
      name: "RNG Casino Queen",
      providerName: "Supernowa",
    },
    RNGCasinoQueen2020: {
      redirectUrl: "/casino/sn-rng-casino-queen-2020",
      code: "RCQ20",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNGCasinoQueen2020.webp",
      alt: "",
      name: "RNG Casino Queen 2020",
      providerName: "Supernowa",
    },
    RNGDragonTiger: {
      redirectUrl: "/casino/sn-rng-dragon-tiger",
      code: "VDT",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNGDragonTiger-new.webp",
      alt: "",
      name: "RNG Dragon Tiger",
      providerName: "Supernowa",
    },
    RNGDragonTiger2020: {
      redirectUrl: "/casino/sn-rng-dragon-tiger-2020",
      code: "VDT20",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNGDragonTiger2020.webp",
      alt: "",
      name: "RNG Dragon Tiger 2020",
      providerName: "Supernowa",
    },
    RNGJoker: {
      redirectUrl: "/casino/sn-rng-joker",
      code: "VJKR",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNGJoker.webp",
      alt: "",
      name: "RNG Joker",
      providerName: "Supernowa",
    },
    RNGKingRace: {
      redirectUrl: "/casino/sn-rng-king-race",
      code: "VCR",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNGKingRace.webp",
      alt: "",
      name: "RNG King Race",
      providerName: "Supernowa",
    },
    RNGLucky7: {
      redirectUrl: "/casino/sn-rng-lucky-7",
      code: "VUD7",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNGLucky7.webp",
      alt: "",
      name: "RNG Lucky 7",
      providerName: "Supernowa",
    },
    RNGTeenPatti: {
      redirectUrl: "/casino/sn-rng-teen-patti",
      code: "VTP",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNGTeenPatti.webp",
      alt: "",
      name: "RNG Teen Patti",
      providerName: "Supernowa",
    },
    RNGTeenPatti2020: {
      redirectUrl: "/casino/sn-rng-teen-patti-2020",
      code: "VTP20",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNGTeenPatti2020.webp",
      alt: "",
      name: "RNG Teen Patti 2020",
      providerName: "Supernowa",
    },
    RNGWorliMatka: {
      redirectUrl: "/casino/sn-rng-worli-matka",
      code: "VWM",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/supernowa/RNGWorliMatka.webp",
      alt: "",
      name: "RNG Worli Matka",
      providerName: "Supernowa",
    },
  },

  instantGames: {
    aviator: {
      redirectUrl: "/casino/spribe/aviator",
      code: "aviator",
      casino: "spribe",
      provider: "aviator",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/alt-gaming/InstantGame/Aviator.webp",
      alt: "",
      name: "Aviator",
      providerName: "Spribe",
    },
    Pushpa: {
      redirectUrl: "/casino/aggapcrash88gaming-pushpa",
      code: "aviator",
      casino: "spribe",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/alt-gaming/InstantGame/pushparani.webp",
      alt: "",
      name: "Pushpa",
      providerName: "ALT_GAMING_GAP",
    },
    mines: {
      redirectUrl: "/casino/spribe/mines",
      code: "mines",
      casino: "spribe",
      provider: "mines",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/alt-gaming/InstantGame/Mines.webp",
      alt: "",
      name: "Mines",
      providerName: "Spribe",
    },
    aero: {
      redirectUrl: "/casino/aggapturbogames-aero",
      code: "",
      casino: "Qtech",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/alt-gaming/InstantGame/Aero.webp",
      alt: "",
      name: "Aero",
      providerName: "Qtech",
    },
    crashX: {
      redirectUrl: "/casino/aggapturbogames-crash-x",
      code: "",
      casino: "Qtech",
      provider: "Qtech",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/alt-gaming/InstantGame/CrashX.webp",
      alt: "",
      name: "Crash X",
      providerName: "Qtech",
    },
    goal: {
      redirectUrl: "/casino/spribe/goal",
      code: "goal",
      casino: "spribe",
      provider: "goal",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/alt-gaming/InstantGame/Goal.webp",
      alt: "",
      name: "Goal",
      providerName: "Spribe",
    },
    dice: {
      redirectUrl: "/casino/spribe/dice",
      code: "dice",
      casino: "spribe",
      provider: "dice",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/alt-gaming/InstantGame/Dice.webp",
      alt: "",
      name: "Dice",
      providerName: "Spribe",
    },
    plinko: {
      redirectUrl: "/casino/spribe/plinko",
      code: "plinko",
      casino: "spribe",
      provider: "plinko",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/alt-gaming/InstantGame/plinko.webp",
      alt: "",
      name: "Plinko",
      providerName: "Spribe",
    },
    miniroulette: {
      redirectUrl: "/casino/spribe/miniroulette",
      code: "mini-roulette",
      casino: "spribe",
      provider: "mini-roulette",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/alt-gaming/InstantGame/Miniroulette.webp",
      alt: "",
      name: "Mini Roulette",
      providerName: "Spribe",
    },
    hilo: {
      redirectUrl: "/casino/spribe/hilo",
      code: "hi-lo",
      casino: "spribe",
      provider: "hi-lo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/alt-gaming/InstantGame/hilo.webp",
      alt: "",
      name: "Hilo",
      providerName: "Spribe",
    },
    keno: {
      redirectUrl: "/casino/spribe/keno",
      code: "keno",
      casino: "spribe",
      provider: "keno",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/alt-gaming/InstantGame/keno.webp",
      alt: "keno",
      name: "Keno",
      providerName: "Spribe",
    },
  },

  providersLobbies: {
    mac88: {
      href: "/casinos?provider=mac88",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lobbyImages/mac88new.webp",
      name: "Mac88",
    },
    evolution: {
      href: "/casino/evolution",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lobbyImages/evolution.webp",
      name: "Evolution",
    },
    evoplay: {
      href: "/casino/evoplay",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lobbyImages/evoplay.webp",
      name: "Evoplay",
    },
    ezugi: {
      href: "/casino/ezugi",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lobbyImages/ezuginew.webp",
      name: "Ezugi",
    },
    jili: {
      href: "/casinos?provider=jili",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lobbyImages/jili.webp",
      name: "Jili",
    },
    qtech: {
      href: "/casino/qtech",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lobbyImages/qtech.webp",
      name: "Qtech",
    },
    redtiger: {
      href: "/casinogames",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lobbyImages/redtiger.webp",
      name: "Red Tiger",
    },
    spribe: {
      href: "/casinos?provider=spribe",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lobbyImages/spribe.webp",
      name: "Spribe",
    },
    supernowa: {
      href: "/casino/supernowa",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lobbyImages/supernowa.webp",
      name: "Supernowa",
    },
  },
  lobbies: {
    Mac88: {
      href: "/casinos?provider=mac88",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/Mac88.webp",
      alt: "Mac88",
      name: "Mac88",
    },
    Spribe: {
      href: "/casinos?provider=spribe",
      code: "",
      casino: "Spribe",
      provider: "Spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/Spribe.webp",
      alt: "Spribe",
      name: "Spribe",
    },
    Mac88VR: {
      href: "/casinos?provider=mac88VR",
      code: "",
      casino: "Mac88 Virtual",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/Mac88VR.webp",
      alt: "Mac88",
      name: "Mac88",
    },
    Evolution: {
      href: "/casino/evolution",
      code: "",
      casino: "Evolution",
      provider: "Evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/Evolution.webp",
      alt: "Evolution",
      name: "Evolution",
    },
    Turbo: {
      href: "/casinos?provider=turbo",
      code: "",
      casino: "Turbo",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/TurboGame.webp",
      alt: "Turbo",
      name: "Turbo",
    },
    SmartSoft: {
      href: "/casinos?provider=smartSoft",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/SmartSoft.webp",
      alt: "SmartSoft",
      name: "SmartSoft",
    },
    Ezugi: {
      href: "/casino/ezugi",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/Ezugi.webp",
      alt: "Ezugi",
      name: "Ezugi",
    },
    Jili: {
      href: "/casinos?provider=jili",
      code: "",
      casino: "Jili",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/Jili.webp",
      alt: "Jili",
      name: "Jili",
    },
    AeSexy: {
      href: "/casino/aesexy",
      code: "",
      casino: "AeSexy",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/AeSexy.webp",
      alt: "AeSexy",
      name: "AeSexy",
    },
    RelaxGaming: {
      href: "/casinos?provider=relaxGaming",
      code: "",
      casino: "Relax Gaming",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/RelaxGaming.webp",
      alt: "Relax Gaming",
      name: "Relax Gaming",
    },
    Kingmaker: {
      href: "/casinos?provider=kingmaker",
      code: "",
      casino: "Kingmaker",
      provider: "Kingmaker",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/Kingmaker.webp",
      alt: "Kingmaker",
      name: "Kingmaker",
    },
    AuraGaming: {
      href: "/casinos?provider=auragaming",
      code: "",
      casino: "Aura",
      provider: "Aura",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/AuraGaming.webp",
      alt: "Aura Gaming",
      name: "Aura Gaming",
    },
    Netent: {
      href: "/casinos?provider=netent",
      code: "",
      casino: "Netent",
      provider: "Netent",
      category: "netent",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/NetEnt.webp",
      alt: "Netent",
      name: "Netent",
    },
    RedTiger: {
      href: "/casinos?provider=redtiger",
      code: "",
      casino: "Red Tiger",
      provider: "Red Tiger",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/RedTiger.webp",
      alt: "Red Tiger",
      name: "Red Tiger",
    },
    Qtech: {
      href: "/casino/qtech",
      code: "",
      casino: "Qtech",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/Qtech.webp",
      alt: "Qtech",
      name: "Qtech",
    },
    Slots: {
      href: "/casinos?provider=slots",
      code: "",
      casino: "Slots",
      provider: "Slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/Slots.webp",
      alt: "Slots",
      name: "Slots",
    },
    Supernowa: {
      href: "/casino/supernowa",
      code: "",
      casino: "Supernowa",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/Supernowa.webp",
      alt: "Supernowa",
      name: "Supernowa",
    },
    Vivo: {
      href: "/casino/vivo",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/Vivo.webp",
      alt: "Vivo",
      name: "Vivo",
    },
    XPG: {
      href: "/casino/xpg",
      code: "",
      casino: "XPG",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/XPG.webp",
      alt: "XPG",
      name: "XPG",
    },
    Worldcasino: {
      href: "/casino/worldcasino",
      code: "",
      casino: "Worldcasino",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/Worldcasino.webp",
      alt: "Worldcasino",
      name: "Worldcasino",
    },
    Powergames: {
      href: "/casinos?provider=powergames",
      code: "",
      casino: "Powergames",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/Powergames.webp",
      alt: "Powergames",
      name: "Powergames",
    },
    Hacksaw: {
      href: "/casinos?provider=hacksaw",
      code: "",
      casino: "Hacksaw",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/Hacksaw.webp",
      alt: "Hacksaw",
      name: "Hacksaw",
    },
    PlayNGo: {
      href: "/casinos?provider=playNGo",
      code: "",
      casino: "Play'n Go",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/PlaynGo.webp",
      alt: "Play'n Go",
      name: "Play'n Go",
    },
    Habanero: {
      href: "/casinos?provider=habanero",
      code: "",
      casino: "Habanero",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/Habanero.webp",
      alt: "Habanero",
      name: "Habanero",
    },
    DragoonSoft: {
      href: "/casinos?provider=dragoonSoft",
      code: "",
      casino: "Dragoon Soft",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-lobby/DragoonSoft.webp",
      alt: "Dragoon Soft",
      name: "Dragoon Soft",
    },
  },
};
